export const PnlOwner = {
  CurrentUser: 'CurrentUser::PnlRelation',
  AnotherUsers: 'AnotherUsers::PnlRelation',
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PnlOwner = (typeof PnlOwner)[keyof typeof PnlOwner]
